import { render, staticRenderFns } from "./UnitKPNG.vue?vue&type=template&id=4776902f&scoped=true&"
import script from "./UnitKPNG.vue?vue&type=script&lang=js&"
export * from "./UnitKPNG.vue?vue&type=script&lang=js&"
import style0 from "./UnitKPNG.vue?vue&type=style&index=0&id=4776902f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776902f",
  null
  
)

export default component.exports